import { render, staticRenderFns } from "./OrderProductListItemIngredient.vue?vue&type=template&id=b73ac578&"
import script from "./OrderProductListItemIngredient.vue?vue&type=script&lang=ts&"
export * from "./OrderProductListItemIngredient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports